import { Component, OnInit, EventEmitter, Output, Input, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from "../../auth/_models/DadosPessoaisAba1";
import { EnumService } from 'app/service/enum/enum';
import { Enum } from 'app/model/enum';
import { DadosPessoaisAba1 } from "../../service/dados-pessoais-aba1/dados-pessoais-aba1";
import { UploadComprovanteService } from 'app/service/upload/upload-comprovante.service';
import { HomeService } from 'app/service/home/home.service';
import { ChangeDetectorRef } from '@angular/core';
import { RelatorioService } from 'app/service/relatorio.service';
import { CampanhasServidorService } from "../../service/campanha-servidor/campanhas-servidor.service";
import { VerificaCampanhaResponseDto } from "../../model/verificaCampanhaResponseDto";

@Component({
  selector: 'app-recadastramento-aba1',
  templateUrl: './recadastramento-aba1.component.html',
  styleUrls: ['./recadastramento-aba1.component.sass']
})
export class RecadastramentoAba1Component implements OnInit, OnChanges {
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild('fileInputConjuge') fileInput!: ElementRef;
  @ViewChild('fileInputGrauInstrucao') fileInputGrauInstrucao!: ElementRef;
  @ViewChild('fileInputEstadoCivil') fileInputEstadoCivil!: ElementRef;

  form: FormGroup;
  isLoadingSpinner: boolean = true;
  user: DadosPessoaisAba1Response = null;
  campanhaUser: VerificaCampanhaResponseDto = null;
  temAnexoEstadoCivil: boolean;
  temAnexoGrauInstrucao: boolean;
  temAnexoDadosConjuge: boolean;
  showEspecifique: boolean
  nomeConjugeOriginal: string;
  estadoCivilOriginal: number
  grauInstrucaoOriginal: number;
  generos: Enum[];
  grausEscolaridade: Enum[];
  racasCor: Enum[];
  estadosCivis: Enum[];
  solicitarAnexoConjuge: boolean = false; // Variável de controle para mostrar/ocultar a solicitação de anexo do cônjuge
  solicitarAnexoInstrucao: boolean = false; // Variável de controle para mostrar/ocultar a solicitação de anexo do grau de instrução
  arquivoSelecionadoEstadoCivil: File;
  arquivoSelecionadoConjuge: File;
  arquivoSelecionadoGrauInstrucao: File;
  isInfoImportantVisible: boolean = true;
  arquivoEnviadoEstadoCivil: boolean = false;
  arquivoEnviadoGrauEscolaridade: boolean = false;
  arquivoEnviadoDadosConjuge: boolean = false;
  requestCounter = 0; // Zera o contador de requisições
  isAlertComprovante: boolean = false;
  dadosPessoais: any;
  enviandoAnexoEstadoCivil: boolean = false;
  enviandoAnexoDadosConjuge: boolean = false;
  enviandoAnexoGrauInstrucao: boolean = false;

  constructor(
    private dadosPessoaisAba1: DadosPessoaisAba1,
    private homeService: HomeService,
    private uploadComprovanteService: UploadComprovanteService,
    private enumService: EnumService,
    private toasterService: ToastrService,
    private relatorioService: RelatorioService,
    private formBuilder: FormBuilder, private cdr: ChangeDetectorRef,
    private campanhasServidorService: CampanhasServidorService) {
    this.form = this.formBuilder.group({
      nome: [''],
      cpf: [''],
      pisPasep: [''],
      nomeConjuge: [''],
      codGrauInstrucao: ['', [Validators.required]],
      racaCor: ['', [Validators.required]],
      codEstadoCivel: ['', [Validators.required]],
      sexo: ['', [Validators.required]],
      isAnexoEstadoCivil: [''],
      isAnexoNomeConjuge: [''],
      isAnexoGrauInstrucao: [''],
      matricula: [''],
      nomePai: [''],
      nomeMae: [''],
      codIdentidadeGenero: ['', [Validators.required]],
      outroGenero: ['']
    });
    this.form.get('nome')?.disable();
    this.form.get('cpf')?.disable();
    this.form.get('pisPasep')?.disable();
  }

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.campanhaUser = new VerificaCampanhaResponseDto();
    this.obterDadosPessoais()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  toggleAlertVisible() {
    this.isAlertComprovante = !this.isAlertComprovante;
  }

  onArquivoSelecionadoEstadoCivil(event: any) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      this.arquivoSelecionadoEstadoCivil = file;
      this.enviarAnexoEstadoCivil();
    }
    else {
      this.arquivoSelecionadoEstadoCivil = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.checkEstadoCivil(true)
    }
  }

  onArquivoSelecionadoConjuge(event: any) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];
    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      this.arquivoSelecionadoConjuge = file;
      this.enviarAnexoDadosConjuge();
    }
    else {
      this.arquivoSelecionadoConjuge = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.onArquivoExcluidoConjuge()
    }
  }
  onArquivoSelecionadoGrauInstrucao(event: any) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];
    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      this.arquivoSelecionadoGrauInstrucao = file;
      this.enviarAnexoGrauInstrucao();
    }
    else {
      this.arquivoSelecionadoGrauInstrucao = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.onArquivoExcluidoGrauInstrucao('erroForm')
    }
  }
  onArquivoExcluidoConjuge() {

      this.dadosPessoaisAba1.deletarComprovanteConjuge().subscribe(resp => {
        this.arquivoEnviadoDadosConjuge = false
        this.arquivoSelecionadoConjuge = null;

      }, error => {
        this.toasterService.error('Erro ao excluir comprovante.', '', {
          timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
        });
      });

    // const input = document.getElementById('input-file-conjuge') as HTMLInputElement;
    // input.value = '';
  }

  onArquivoExcluidoGrauInstrucao(erroForm) {

    if (erroForm == 'clickIcon') {
      this.dadosPessoaisAba1.deletarComprovanteGrauEscolaridade().subscribe(resp => {
        this.toasterService.success('Arquivo excluído com sucesso.', '', {
          timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
        });
        this.arquivoEnviadoGrauEscolaridade = false
        this.arquivoSelecionadoGrauInstrucao = null;
      }, error => {
        this.toasterService.error('Erro ao excluir comprovante.', '', {
          timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
        });
      });
    }
    const input = document.getElementById('input-file-grau-instrucao') as HTMLInputElement;
    input.value = '';

  }
  obterDadosPessoais(): void {
    // Realize o GET novamente aqui
    this.dadosPessoaisAba1.getDadosPessoais().subscribe((dados) => {
      this.dadosPessoais = dados;
      this.carregadorDadosIniciais(dados);
    });
  }
  private carregadorDadosIniciais(dados) {
    if (dados) {
      // organize a posição dos campos como achar melhor meu caro ;)
      this.arquivoEnviadoEstadoCivil = dados.isAnexoEstadoCivil
      this.form.get('isAnexoEstadoCivil').setValue(dados.isAnexoEstadoCivil)

      this.arquivoEnviadoDadosConjuge = dados.isAnexoConjuge
      this.form.get('isAnexoNomeConjuge').setValue(dados.isAnexoConjuge)
      this.form.get('isAnexoGrauInstrucao').setValue(dados.isAnexoGrauEscolaridade)
      this.enviandoAnexoEstadoCivil= true

      this.enviandoAnexoGrauInstrucao = true

      this.enviandoAnexoDadosConjuge = true
      this.arquivoEnviadoGrauEscolaridade = dados.isAnexoGrauEscolaridade

      this.nomeConjugeOriginal = dados.nomeConjuge;
      this.estadoCivilOriginal = dados.codEstadoCivel;
      this.grauInstrucaoOriginal = dados.codGrauInstrucao;
      const generoEmInteiro = dados.codIdentidadeGenero != null ? Number(dados.codIdentidadeGenero) : null;
      this.form.patchValue({
        nome: dados.nome,
        nomeConjuge: dados.nomeConjuge,
        nomePai: dados.nomePai,
        nomeMae: dados.nomeMae,
        cpf: dados.cpf,
        codGrauInstrucao: dados.codGrauInstrucao,
        sexo: dados.sexo,
        racaCor: dados.racaCor,
        codEstadoCivel: dados.codEstadoCivel,
        matricula: dados.matricula,
        codIdentidadeGenero: generoEmInteiro,
        outroGenero: dados.outroGenero,
        pisPasep: dados.pisPasep,
      });
      if (generoEmInteiro == 7) {
        this.showEspecifique = true;
      }
      this.incrementRequestCounter();
      this.buscarGeneros();
      this.incrementRequestCounter();
      this.buscarRacaCor();
      this.incrementRequestCounter();
      this.buscarEstadoCivil();
      this.incrementRequestCounter();
      this.buscarGrausEscolaridade();
      this.incrementRequestCounter();
      this.getVerificarConclusaoRecadastramento()
    }
  }
  private buscarGeneros(): void {
    this.enumService.buscarGeneros().subscribe(resp => {
      this.generos = resp;
      this.decrementRequestCounter();
    }, error => {
      console.error(error);
    })
  }
  private buscarRacaCor(): void {
    this.enumService.buscarRacaCor().subscribe(resp => {
      this.racasCor = resp;
      this.decrementRequestCounter();
    }, error => {
      console.error(error);
    });
  }
  private buscarEstadoCivil(): void {
    this.enumService.buscarEstadoCivil().subscribe(resp => {
      // this.racasCor = resp;
      this.estadosCivis = resp
      this.decrementRequestCounter();
    }, error => {
      console.error(error);
    });
  }
  private buscarGrausEscolaridade(): void {
    this.enumService.buscarGrausEscolaridade().subscribe(resp => {
      this.grausEscolaridade = resp;
      this.decrementRequestCounter();
    }, error => {
      console.error(error);
    })
  }

  getVerificarConclusaoRecadastramento() {
    this.campanhasServidorService.verificarCampanhaRecadastramento().subscribe(resp => {
      this.campanhaUser = resp;
      this.decrementRequestCounter();
    })
  }
  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso.', '', {
      timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
    });
  }
  visualizarComprovanteGrauEscolaridade(): void {
    this.dadosPessoaisAba1.visualizarComprovanteGrauEscolaridade().subscribe((response: Blob) => {
      const fileName = 'Comprovante_Grau_Escolaridade';
      const fileType = this.getFileTypeFromBlob(response);
      if (fileType === null) {
        return;
      }

      const blob = new Blob([response], { type: fileType });
      // Inicia o download do arquivo
      saveAs(blob, fileName + '.' + fileType);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo.', '', {
        timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
    });
  }

  private getFileTypeFromBlob(blob: Blob): string | null {
    if (blob.type) {
      const contentType = blob.type.toLowerCase();
      if (contentType.includes('pdf')) {
        return 'pdf';
      } else if (contentType.includes('jpeg') || contentType.includes('jpg')) {
        return 'jpeg';
      } else if (contentType.includes('png')) {
        return 'png';
      }
    }
    return null;
  }

  extractFileName(contentDispositionHeader: string): string {
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(contentDispositionHeader);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
    return '';
  }

  extractFileExtension(fileName: string): string {
    const fileExtensionRegex = /(?:\.([^.]+))?$/;
    const matches = fileExtensionRegex.exec(fileName);
    if (matches != null && matches[1]) {
      return matches[1].toLowerCase();
    }
    return '';
  }
  visualizarComprovanteConjuge(): void {
    this.dadosPessoaisAba1.visualizarComprovanteConjuge().subscribe((response: Blob) => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const fileType = response.type || 'application/octet-stream'; // Tipo

      let fileName = 'Comprovante_Conjuge';
      const fileExtension = this.getFileExtensionFromMimeType(fileType);

      if (fileExtension) {
        fileName += '.' + fileExtension;
      }

      // Inicia o download do arquivo
      this.downloadFile(blob, fileName);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo.', '', {
        timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
    });
  }

  visualizarArquivoEstadoCivil(): void {
    this.dadosPessoaisAba1.visualizarComprovanteEstadoCivil().subscribe((response: Blob) => {
      const fileType = response.type || 'application/octet-stream'; // Tipo

      let fileName = 'Comprovante_Estado_Civil';
      const fileExtension = this.getFileExtensionFromMimeType(fileType);

      if (fileExtension) {
        fileName += '.' + fileExtension;
      }

      const blob = new Blob([response], { type: fileType });
      // Inicia o download do arquivo
      this.downloadFile(blob, fileName);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo.', '', {
        timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
    });
  }

  visualizarArquivoFinal(): void {
    this.relatorioService.gerarRelatorio('relatorioComprovanteRecadastramento').subscribe((resp: Blob) => {
      let blob: Blob;
      const fileType = resp.type || 'application/octet-stream';

      let fileName = 'Conclusão_Recadastramento'
      const fileExtension = this.getFileExtensionFromMimeType(fileType);

      if (fileExtension) {
        fileName += '.' + fileExtension;
      }

      blob = new Blob([resp], { type: fileType });
      this.downloadFile(blob, fileName);
    })
  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
    const extensionMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'image/png': 'png'
      // Adicione outras extensões e tipos MIME conforme necessário
    };

    return extensionMap[mimeType] || null;
  }
  onGeneroChange() {
    const generoControl = this.form.get('codIdentidadeGenero');
    const especifiqueControl = this.form.get('outroGenero');
    if (generoControl.value === 7) {
      especifiqueControl.setValidators([Validators.required]);
      this.showEspecifique = true;
    } else {
      especifiqueControl.clearValidators();
      this.form.get('outroGenero').setValue(''); // Limpa o campo "outroGenero"
      this.showEspecifique = false;
    }

    especifiqueControl.updateValueAndValidity();
  }

  checkTesteNomeConjuge() {
    const valorNomeConjuge: string = this.nomeConjugeOriginal;
    const verificarValorNomeConjuge: string = valorNomeConjuge ? valorNomeConjuge : '';
    const valorNomeConjugeDoForm: string = this.form.value.nomeConjuge;
    const verificarValorNomeConjugeDoForm: string = valorNomeConjugeDoForm ? valorNomeConjugeDoForm : '';

    if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge != this.form.get('isAnexoNomeConjuge').value) {
      this.form.get('isAnexoNomeConjuge').setValue(true)
    }
    if (verificarValorNomeConjuge != verificarValorNomeConjugeDoForm ) {
      this.temAnexoDadosConjuge = true
      this.enviandoAnexoDadosConjuge = false
      this.form.get('isAnexoNomeConjuge').setValue(false)
    }
    else if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge == false && this.form.get('isAnexoNomeConjuge').value== false) {
      this.temAnexoDadosConjuge = false
      //this.arquivoEnviadoEstadoCivil = true
      this.enviandoAnexoDadosConjuge = true
    }
    else if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge != this.form.get('isAnexoNomeConjuge').value) {
      this.temAnexoDadosConjuge = true
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoNomeConjuge').setValue(false)
    }
    else if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge && this.form.get('isAnexoNomeConjuge').value == false) {
      this.temAnexoDadosConjuge = true
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoNomeConjuge').setValue(false)
    }
    else if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge && this.form.get('isAnexoNomeConjuge').value) {
      this.temAnexoDadosConjuge = false
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoNomeConjuge').setValue(true)

    }
  }
  checkNomeConjuge(excluirAnexo: boolean) {
    // Verificar se o campo Nome do Cônjuge foi modificado
    const valorNomeConjuge: string = this.nomeConjugeOriginal;
    const verificarValorNomeConjuge: string = valorNomeConjuge ? valorNomeConjuge : '';
    const valorNomeConjugeDoForm: string = this.form.value.nomeConjuge;
    const verificarValorNomeConjugeDoForm: string = valorNomeConjugeDoForm ? valorNomeConjugeDoForm : '';
    if (verificarValorNomeConjugeDoForm == '') {
      this.temAnexoDadosConjuge = false

      this.arquivoEnviadoDadosConjuge == false && this.arquivoSelecionadoConjuge == null ? false : this.onArquivoExcluidoConjuge();
      return false
    }

    if (verificarValorNomeConjugeDoForm !== verificarValorNomeConjuge && excluirAnexo == false) {
      this.temAnexoDadosConjuge = true
      this.form.get('isAnexoNomeConjuge').setValue(false)
      this.enviandoAnexoDadosConjuge = false
      //this.arquivoEnviadoEstadoCivil = false
      return true
    }

    else if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge != this.form.get('isAnexoNomeConjuge').value && excluirAnexo == false) {
      this.temAnexoDadosConjuge = true
      this.enviandoAnexoDadosConjuge = false

      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoNomeConjuge').setValue(false)


      return true
    }
    else if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge == this.form.get('isAnexoNomeConjuge').value && excluirAnexo == false) {
      this.temAnexoDadosConjuge = false
      this.enviandoAnexoDadosConjuge = true
      this.form.get('isAnexoNomeConjuge').setValue(this.form.get('isAnexoNomeConjuge').value)


      return false
    }
    else if (verificarValorNomeConjuge == verificarValorNomeConjugeDoForm && this.arquivoEnviadoDadosConjuge && this.form.get('isAnexoNomeConjuge').value && excluirAnexo == false) {
      this.temAnexoDadosConjuge = false

      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoNomeConjuge').setValue(true)

      return false
    }
    else if (excluirAnexo) {
      this.form.get('isAnexoNomeConjuge').setValue(false);

      this.temAnexoDadosConjuge = true
      this.enviandoAnexoDadosConjuge = false

      this.toasterService.success('Arquivo excluído com sucesso.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
    }

  }

  // checkGrauInstrucao() {
  //   if (this.form.value.codGrauInstrucao !== this.grauInstrucaoOriginal) {
  //     this.temAnexoGrauInstrucao = true
  //     return true; // Solicitar anexo do grau de instrução
  //   } else {
  //     this.temAnexoGrauInstrucao = false
  //     return false; // Não solicitar anexo do grau de instrução
  //   }
  // }

  checkTesteGrauInstrucao() {
    if (this.grauInstrucaoOriginal == this.form.value.codGrauInstrucao && this.arquivoEnviadoGrauEscolaridade &&  this.form.get('isAnexoGrauInstrucao').value == false) {
      this.form.get('isAnexoEstadoCivil').setValue(true)
      this.enviandoAnexoGrauInstrucao = false

    }
    if (this.grauInstrucaoOriginal != this.form.value.codGrauInstrucao ) {
      this.temAnexoGrauInstrucao= true
      this.enviandoAnexoGrauInstrucao = false

      this.form.get('isAnexoGrauInstrucao').setValue(false)
    }
    else if (this.grauInstrucaoOriginal == this.form.value.codGrauInstrucao && this.arquivoEnviadoGrauEscolaridade == false && this.form.get('isAnexoGrauInstrucao').value== false) {
      this.temAnexoGrauInstrucao = false
      //this.arquivoEnviadoEstadoCivil = true
      this.enviandoAnexoGrauInstrucao = true
    }

    else if (this.grauInstrucaoOriginal == this.form.value.codGrauInstrucao && this.arquivoEnviadoGrauEscolaridade && this.form.get('isAnexoGrauInstrucao').value == false) {
      this.temAnexoGrauInstrucao = false
      this.enviandoAnexoGrauInstrucao = false
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoGrauInstrucao').setValue(true)
    }
    else if (this.grauInstrucaoOriginal == this.form.value.codGrauInstrucao && this.arquivoEnviadoGrauEscolaridade && this.form.get('isAnexoGrauInstrucao').value) {
      this.temAnexoGrauInstrucao = false
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoGrauInstrucao').setValue(true)

    }
  }

  checkEstadoCivil(excluirAnexo: boolean) {
    // Verificar se o campo Estado Civil foi modificado

    if (this.estadoCivilOriginal != this.form.value.codEstadoCivel && excluirAnexo == false) {
      this.temAnexoEstadoCivil = true
      this.form.get('isAnexoEstadoCivil').setValue(false)
      this.enviandoAnexoEstadoCivil = false
      //this.arquivoEnviadoEstadoCivil = false
      return true
    }

    else if (this.estadoCivilOriginal == this.form.value.codEstadoCivel && this.arquivoEnviadoEstadoCivil != this.form.get('isAnexoEstadoCivil').value && excluirAnexo == false) {
      this.temAnexoEstadoCivil = true
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoEstadoCivil').setValue(false)

      return true
    }
    else if (this.estadoCivilOriginal == this.form.value.codEstadoCivel && this.arquivoEnviadoEstadoCivil && this.form.get('isAnexoEstadoCivil').value && excluirAnexo == false) {
      this.temAnexoEstadoCivil = false
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoEstadoCivil').setValue(true)

      return false
    }
    else if (excluirAnexo) {
      this.form.get('isAnexoEstadoCivil').setValue(false);

      this.temAnexoEstadoCivil = true
      //this.arquivoEnviadoEstadoCivil = false
      this.enviandoAnexoEstadoCivil = false
      this.toasterService.success('Arquivo excluído com sucesso.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      //return false

      // this.dadosPessoaisAba1.deletarComprovanteEstadoCivil().subscribe(resp => {
      //   this.toasterService.success('Arquivo excluído com sucesso.', '', {
      //     timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      //   });
      //   this.arquivoEnviadoEstadoCivil = false
      //   this.arquivoSelecionadoEstadoCivil = null;
      // }, error => {
      //   this.toasterService.error('Erro ao excluir comprovante.', '', {
      //     timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      //   });
      // });

      // const input = document.getElementById('input-file-estado-civil') as HTMLInputElement;
      // input.value = '';
    }
    // if (this.estadoCivilOriginal != this.form.value.codEstadoCivel) {
    //   this.temAnexoEstadoCivil = true
    //   return true
    // } else {
    //   this.temAnexoEstadoCivil = false
    //   return false
    // }
  }
  checkTeste() {
    if (this.estadoCivilOriginal == this.form.value.codEstadoCivel && this.arquivoEnviadoEstadoCivil != this.form.get('isAnexoEstadoCivil').value) {
      this.form.get('isAnexoEstadoCivil').setValue(true)
      this.enviandoAnexoEstadoCivil = false
    }
    if (this.estadoCivilOriginal != this.form.value.codEstadoCivel ) {
      this.temAnexoEstadoCivil = true
      this.enviandoAnexoEstadoCivil = false
      this.form.get('isAnexoEstadoCivil').setValue(false)
    }
    else if (this.estadoCivilOriginal == this.form.value.codEstadoCivel && this.arquivoEnviadoEstadoCivil == false && this.form.get('isAnexoEstadoCivil').value == false) {
      this.temAnexoEstadoCivil = false
      //this.arquivoEnviadoEstadoCivil = true
      this.enviandoAnexoEstadoCivil = true
    }

    else if (this.estadoCivilOriginal == this.form.value.codEstadoCivel && this.arquivoEnviadoEstadoCivil != this.form.get('isAnexoEstadoCivil').value) {
      this.temAnexoEstadoCivil = false
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoEstadoCivil').setValue(false)
    }
    else if (this.estadoCivilOriginal == this.form.value.codEstadoCivel && this.arquivoEnviadoEstadoCivil && this.form.get('isAnexoEstadoCivil').value) {
      this.temAnexoEstadoCivil = false
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoEstadoCivil').setValue(true)

    }
  }

  checkGrauInstrucao(excluirAnexo: boolean) {
    // Verificar se o campo Estado Civil foi modificado

    if (this.grauInstrucaoOriginal != this.form.value.codGrauInstrucao && excluirAnexo == false) {
      this.temAnexoGrauInstrucao = true
      this.enviandoAnexoGrauInstrucao = false
      this.form.get('isAnexoGrauInstrucao').setValue(false)

      //this.arquivoEnviadoEstadoCivil = false
      return true
    }

    else if (this.grauInstrucaoOriginal == this.form.value.codGrauInstrucao && this.arquivoEnviadoGrauEscolaridade != this.form.get('isAnexoGrauInstrucao').value && excluirAnexo == false) {
      this.temAnexoGrauInstrucao = true
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoGrauInstrucao').setValue(false)

      return true
    }
    else if (this.grauInstrucaoOriginal == this.form.value.codGrauInstrucao && this.arquivoEnviadoGrauEscolaridade && this.form.get('isAnexoGrauInstrucao').value && excluirAnexo == false) {
      this.temAnexoGrauInstrucao = false
      //this.arquivoEnviadoEstadoCivil = true
      this.form.get('isAnexoGrauInstrucao').setValue(true)

      return false
    }
    else if (excluirAnexo) {
      this.form.get('isAnexoGrauInstrucao').setValue(false);

      this.temAnexoGrauInstrucao = true
      this.enviandoAnexoGrauInstrucao = false

      this.toasterService.success('Arquivo excluído com sucesso.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      //return false

      // this.dadosPessoaisAba1.deletarComprovanteEstadoCivil().subscribe(resp => {
      //   this.toasterService.success('Arquivo excluído com sucesso.', '', {
      //     timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      //   });
      //   this.arquivoEnviadoEstadoCivil = false
      //   this.arquivoSelecionadoEstadoCivil = null;
      // }, error => {
      //   this.toasterService.error('Erro ao excluir comprovante.', '', {
      //     timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      //   });
      // });

      // const input = document.getElementById('input-file-estado-civil') as HTMLInputElement;
      // input.value = '';
    }
    // if (this.estadoCivilOriginal != this.form.value.codEstadoCivel) {
    //   this.temAnexoEstadoCivil = true
    //   return true
    // } else {
    //   this.temAnexoEstadoCivil = false
    //   return false
    // }
  }

  atualizarDadosPessoais() {
    // Verificar se o campo de estado civil foi alterado
    if (this.checkEstadoCivil(false) && this.checkNomeConjuge(false) && this.checkGrauInstrucao(false)) {
      this.isAlertComprovante = true
    }
    if (this.checkEstadoCivil(false)) {
      // Verificar se um arquivo foi anexado
      if (!this.arquivoSelecionadoEstadoCivil && !this.form.get('isAnexoEstadoCivil').value && this.isAlertComprovante) {
        this.toasterService.warning('Atenção: Campo Anexar Comprovante do Estado Civil é obrigatório!');

        return; // Retorna aqui para interromper a execução caso não haja arquivo anexado
      } else if (!this.arquivoSelecionadoEstadoCivil && !this.isAlertComprovante) {
        this.toasterService.warning('Atenção: Campo Anexar Comprovante do Estado Civil é obrigatório!');
        return; // Retorna aqui para interromper a execução caso não haja arquivo anexado
      }
    }
    if (this.checkNomeConjuge(false)) {
      // Verificar se um arquivo foi anexado
      if (!this.arquivoSelecionadoConjuge && !this.form.get('isAnexoNomeConjuge').value && this.isAlertComprovante) {
        this.toasterService.warning('Atenção: Campo Anexar Comprovante do Dados Cônjuge é obrigatório!');
        return; // Retorna aqui para interromper a execução caso não haja arquivo anexado
      }
      else if (!this.arquivoSelecionadoConjuge && !this.isAlertComprovante) {
        this.toasterService.warning('Atenção: Campo Anexar Comprovante do Dados Cônjuge é obrigatório!');
        return;
      }
    }
    if (this.checkGrauInstrucao(false)) {
      // Verificar se um arquivo foi anexado
      if (!this.arquivoSelecionadoGrauInstrucao && !this.form.get('isAnexoNomeConjuge').value && this.isAlertComprovante) {
        this.toasterService.warning('Atenção: Campo Anexar Comprovante grau instrução é obrigatório!');

        return; // Retorna aqui para interromper a execução caso não haja arquivo anexado
      }
      else if (!this.arquivoSelecionadoGrauInstrucao && !this.isAlertComprovante) {
        this.toasterService.warning('Atenção: Campo Anexar Comprovante grau instrução é obrigatório!');
        return;
      }
    }
    if (this.form.valid) {
      // Lógica para enviar os dados do formulário
      this.dadosPessoaisAba1.atualizarDadosPessoais(this.form.value).subscribe(
        (response) => {
          this.toasterService.success('Dados atualizados com sucesso');
          this.dadosSalvos.emit();
          this.formularioSalvo.emit();

        },
        (error) => {
          this.toasterService.error('Erro ao atualizar os dados');
        }
      );
    } else {
      this.toasterService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
    }

  }
  enviarAnexoEstadoCivil() {
    this.enviandoAnexoEstadoCivil = true
    if (this.arquivoSelecionadoEstadoCivil) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      this.uploadComprovanteService.uploadComprovanteEstadoCivil(this.getFormData(this.arquivoSelecionadoEstadoCivil)).subscribe(
        (response) => {
          this.toasterService.success('Arquivo enviado.', '', {
            timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.fileInputEstadoCivil.nativeElement.value = '';
          this.arquivoEnviadoEstadoCivil = true
          this.enviandoAnexoEstadoCivil = false
          this.form.get('isAnexoEstadoCivil').setValue(true)
        },
        (error) => {
          this.fileInputEstadoCivil.nativeElement.value = '';
          this.arquivoEnviadoEstadoCivil = !this.arquivoEnviadoEstadoCivil
          if (error.status == 422) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
          } else {
            this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`, '', {
              timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
            });
          }
          this.checkEstadoCivil(true)

        }
      );
    }
  }
  enviarAnexoDadosConjuge() {
    this.enviandoAnexoDadosConjuge = true
    if (this.arquivoSelecionadoConjuge) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      this.uploadComprovanteService.uploadComprovanteConjuge(this.getFormData(this.arquivoSelecionadoConjuge)).subscribe(
        (response) => {
          this.toasterService.success('Arquivo enviado.', '', {
            timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.arquivoEnviadoDadosConjuge = true
          this.enviandoAnexoDadosConjuge = false
          this.fileInput.nativeElement.value = '';
          this.form.get('isAnexoNomeConjuge').setValue(true)
        },
        (error) => {
          this.fileInput.nativeElement.value = '';
          if (error.status == 422) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
          } else {
            this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`, '', {
              timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
            });
          }
          this.arquivoEnviadoDadosConjuge = false
          //this.onArquivoExcluidoConjuge()
          this.checkNomeConjuge(true);
        }
      );
    }
  }
  enviarAnexoGrauInstrucao() {
    this.enviandoAnexoGrauInstrucao = true
    if (this.arquivoSelecionadoGrauInstrucao) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      this.uploadComprovanteService.uploadComprovanteGrauEscolaridade(this.getFormData(this.arquivoSelecionadoGrauInstrucao)).subscribe(
        (response) => {
          this.toasterService.success('Arquivo enviado.', '', {
            timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.fileInputGrauInstrucao.nativeElement.value = '';
          this.arquivoEnviadoGrauEscolaridade = true
          this.enviandoAnexoGrauInstrucao = false
          this.form.get('isAnexoGrauInstrucao').setValue(true)

        },
        (error) => {
          this.fileInputGrauInstrucao.nativeElement.value = '';
          this.arquivoEnviadoGrauEscolaridade = !this.arquivoEnviadoGrauEscolaridade
          if (error.status == 422) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
          } else {
            this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`, '', {
              timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
            });
          }
          //this.onArquivoExcluidoGrauInstrucao(error)
          this.checkGrauInstrucao(true);
        }
      );
    }
  }
  getFormData(file: File): FormData {
    let formData = new FormData();
    formData.append('documento', file);
    return formData;
  }
  private incrementRequestCounter(): void {
    this.requestCounter++;
  }

  private decrementRequestCounter(): void {
    this.requestCounter--;

    if (this.requestCounter === 0) {
      this.isLoadingSpinner = false; // Desativa o loading quando todas as requisições forem concluídas
    }
  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}
